import { plainToClass } from "class-transformer";
import formatISO from "date-fns/formatISO";
import AuthorizationService from "../services/authorizationService";
import RepositoryBase from "./repositoryBase";
import EshopError from "../models/eshopError";
import EshopRequestBuilder from "../data/eshopRequestBuilder";
import ChargeRegistrationReport from "../models/chargeRegistrationReport";
import EventBus from "../services/eventBus";
import VehicleRegistrationsResponse from "models/vehicleRegistrationsResponse";
import ChargeRegistrationsResponse from "entities/chargeRegistrationsResponse";

export const GET_CHARGE_REGISTRATIONS_REQUEST_FAILURE = "GET_CHARGE_REGISTRATIONS_REQUEST_FAILURE";
export const GET_VEHICLE_REGISTRATIONS_REQUEST_FAILURE = "GET_VEHICLE_REGISTRATIONS_REQUEST_FAILURE";
const POST_VEHICLE_REGISTRATIONS_REPORT_REQUEST_FAILURE = "POST_VEHICLE_REGISTRATIONS_REPORT_REQUEST_FAILURE";

export default class ChargeRegistrationRepository extends RepositoryBase<EshopRequestBuilder> {
  constructor(
    protected apiFactory: ReturnType<typeof EshopRequestBuilder.Factory>,
    protected authorizationService: AuthorizationService,
    protected eventBus: EventBus
  ) {
    super(() => apiFactory(), authorizationService, eventBus);
  }

  vehicleRegistrationsReport(countryId: string, licensePlates: string[], validSince?: Date) {
    return this.callApi(() =>
      this.apiFactory()
        .one("vehicle_registrations/report")
        .clearPost({ licensePlates, countryId, validSince })
        .then(async response => {
          if (!response.ok) return plainToClass(EshopError, (await response.json()) as EshopError);

          return plainToClass(ChargeRegistrationReport, (await response.json()) as ChargeRegistrationReport);
        })
        .catch(() => new EshopError(POST_VEHICLE_REGISTRATIONS_REPORT_REQUEST_FAILURE))
    );
  }

  getWithCharge(countryId: string, licensePlate: string) {
    return this.callApi(api =>
      api
        .apiVersion(3)
        .one(`charge_registrations/${countryId}/${licensePlate}`)
        .get<ChargeRegistrationsResponse>()
        .then(response => {
          return plainToClass(ChargeRegistrationsResponse, response);
        })
        .catch(() => new EshopError(GET_CHARGE_REGISTRATIONS_REQUEST_FAILURE))
    );
  }

  vehicleRegistration(countryId: string, licensePlate: string, validSince?: Date) {
    const queryValidSince = validSince ? new Date(validSince) : undefined;

    return this.callApi(api =>
      api
        .apiVersion(2)
        .one(`vehicle_registrations/${countryId}/${licensePlate}`)
        .get(
          queryValidSince
            ? {
                // eslint-disable-next-line
                valid_since: formatISO(queryValidSince),
              }
            : {}
        )
        .then(response => {
          return plainToClass(VehicleRegistrationsResponse, response);
        })
        .catch(() => new EshopError(GET_VEHICLE_REGISTRATIONS_REQUEST_FAILURE))
    );
  }
}
